/**
 * 导航服务 - 用于在非组件环境中进行路由跳转
 * 解决 API 拦截器中无法直接使用 React Router 的问题
 */

let navigate: ((to: string, options?: { replace?: boolean }) => void) | null = null;

/**
 * 设置导航函数
 * 需要在应用启动时调用，传入 useNavigate 返回的函数
 */
export const setNavigate = (navigateFunction: (to: string, options?: { replace?: boolean }) => void) => {
  navigate = navigateFunction;
};

/**
 * 程序化导航到指定路径
 * @param to 目标路径
 * @param options 导航选项
 */
export const navigateTo = (to: string, options?: { replace?: boolean }) => {
  if (navigate) {
    navigate(to, options);
  } else {
    console.warn('导航函数未初始化，使用 window.location 作为后备方案');
    // 作为后备方案，仍然使用 window.location，但添加 hash 路由前缀
    if (options?.replace) {
      window.location.replace(`#${to}`);
    } else {
      window.location.href = `#${to}`;
    }
  }
};

/**
 * 跳转到登录页面
 */
export const navigateToLogin = () => {
  navigateTo('/auth/login', { replace: true });
};

/**
 * 跳转到首页
 */
export const navigateToHome = () => {
  navigateTo('/', { replace: true });
};